// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent } from './ui/card';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import {
  Search,
  ArrowUpAZ,
  ArrowDownAZ,
  Calendar,
  SortAsc,
  SortDesc,
} from 'lucide-react';

/**
 * Search input + sort dropdown shown above the Documents list.
 */
export default function DocumentsToolbar({
  searchQuery,
  onSearchChange,
  sortBy,
  sortOrder,
  setSortBy,
  setSortOrder,
}) {
  const sortLabel =
    sortBy === 'name' ? 'Nome' : sortBy === 'date' ? 'Data' : 'Tamanho';
  const SortIcon = sortOrder === 'asc' ? SortAsc : SortDesc;

  return (
    <Card className="border-0 shadow-card rounded-xl">
      <CardContent className="p-4">
        <div className="flex gap-3 items-center">
          <div className="relative group flex-1">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 group-focus-within:text-slate-600 transition-colors" />
            <Input
              placeholder="Buscar arquivos e pastas..."
              value={searchQuery}
              onChange={onSearchChange}
              className="pl-11 h-12 rounded-xl border-slate-200 bg-white focus:ring-2 focus:ring-slate-900/10 focus:border-slate-400 transition-all"
              data-testid="search-files-input"
            />
          </div>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="outline"
                className="h-12 rounded-xl border-slate-200 gap-2"
                data-testid="sort-trigger"
              >
                <SortIcon className="w-4 h-4" />
                <span className="hidden sm:inline">{sortLabel}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <DropdownMenuItem
                onClick={() => { setSortBy('name'); setSortOrder('asc'); }}
                className="gap-2"
                data-testid="sort-name-asc"
              >
                <ArrowUpAZ className="w-4 h-4" />
                Nome (A-Z)
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => { setSortBy('name'); setSortOrder('desc'); }}
                className="gap-2"
                data-testid="sort-name-desc"
              >
                <ArrowDownAZ className="w-4 h-4" />
                Nome (Z-A)
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={() => { setSortBy('date'); setSortOrder('desc'); }}
                className="gap-2"
                data-testid="sort-date-desc"
              >
                <Calendar className="w-4 h-4" />
                Mais recentes
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => { setSortBy('date'); setSortOrder('asc'); }}
                className="gap-2"
                data-testid="sort-date-asc"
              >
                <Calendar className="w-4 h-4" />
                Mais antigos
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={() => { setSortBy('size'); setSortOrder('desc'); }}
                className="gap-2"
                data-testid="sort-size-desc"
              >
                <SortDesc className="w-4 h-4" />
                Maior tamanho
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => { setSortBy('size'); setSortOrder('asc'); }}
                className="gap-2"
                data-testid="sort-size-asc"
              >
                <SortAsc className="w-4 h-4" />
                Menor tamanho
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </CardContent>
    </Card>
  );
}
